export enum ConflictResolution {
  none,
  source,
  target
}
